import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor() { }


  //#region ----------------------------------------------------- base url ------------------------------------------------------//

  baseUrls(url: any) {
    switch (url) {
      //Test server base url
      case 'vehicleTrackingBaseUrlApi': return 'https://vehicle-tracking.mahakhanij.in/'; break;
      case 'stplVtsTrackingBaseUrlAPI': return 'https://vehicle-tracking.mahakhanij.in/'; break;
      case 'masterBaseurlApi': return 'https://master.mahakhanij.in/'; break;
      case 'mineralBaseurlApi': return 'https://mineral-mapping.mahakhanij.in/'; break;
      case 'accountingBaseurlApi': return 'https://mining-accounting.mahakhanij.in/'; break;
      case 'mineralMappingApi': return 'https://mineral-mapping.mahakhanij.in/mineral-mapping/'; break;
      case 'mineralProjectApi': return 'https://mineral-project.mahakhanij.in/mineral-project/'; break;
      case 'gpsStgTraking': return 'https://gps.mahakhanij.in/gps-data-provider/api/v2/'; break;
      default: return ''; break;

      // live server API Base Url
      // case 'vehicleTrackingBaseUrlApi': return 'https://mahakhanij.maharashtra.gov.in/'; break;
      // case 'stplVtsTrackingBaseUrlAPI': return 'https://mahakhanij.maharashtra.gov.in/'; break;
      // case 'masterBaseurlApi': return ' https://mahakhanij.maharashtra.gov.in/'; break;
      // case 'mineralBaseurlApi': return 'https://mahakhanij.maharashtra.gov.in/'; break;
      // case 'accountingBaseurlApi': return 'https://mahakhanij.maharashtra.gov.in/'; break;
      // case 'mineralMappingApi': return 'https://mahakhanij.maharashtra.gov.in/mineral-mapping/'; break;
      // case 'mineralProjectApi': return 'https://mahakhanij.maharashtra.gov.in/mineral-project/'; break;
      // case 'gpsStgTraking': return 'https://gps.mahakhanij.in/gps-data-provider/api/v2/'; break;
      // default: return 'https://mahakhanij.maharashtra.gov.in/'; break;


      //with JWT Token
      // case 'vehicleTrackingBaseUrlApi': return 'http://audit-mahaservice.harmining.com/'; break;
      // case 'stplVtsTrackingBaseUrlAPI': return 'https://mahakhanij.maharashtra.gov.in/'; break;
      // default: return ''; break;

      //with JWT Token
      // case 'vehicleTrackingBaseUrlApi': return 'http://staging-mahaservice.mahamining.com/'; break;
      // case 'stplVtsTrackingBaseUrlAPI': return 'https://mahakhanij.maharashtra.gov.in/'; break;
      // default: return ''; break;
    }
  }


  //#endregion  ----------------------------------------------------- base url ------------------------------------------------------//

  static googleApiObj: object = { // google api key
    apiKey: 'AIzaSyC051H4kydmuuevDaHxJ8qoByrWYi3015c',//live
    language: 'en',
    libraries: ['drawing', 'places']
  };


  static ToastrModuleOptions: object = {
    timeOut: 2000,
    closeButton: true,
    progressBar: true,
    preventDuplicates: true,
  }

  billDesk = {
    merchantId: 'UATDGEMV2',
  }
  bookingTimeSlot = [{ text: '10:00 AM To 10:10 AM', val: '10:00 10:10' }, { text: '10:10 AM To 10:20 AM', val: '10:10 10:20' }, { text: '10:20 AM To 10:30 AM', val: '10:20 10:30' }, { text: '10:30 AM To 10:40 AM', val: '10:30 10:40' }, { text: '10:40 AM To 10:50 AM', val: '10:40 10:50' }, { text: '10:50 AM To 11:00 AM', val: '10:50 11:00' }, { text: '11:00 AM To 11:10 AM', val: '11:00 11:10' }, { text: '11:10 AM To 11:20 AM', val: '11:10 11:20' }, { text: '11:20 AM To 11:30 AM', val: '11:20 11:30' }, { text: '11:30 AM To 11:40 AM', val: '11:30 11:40' }, { text: '11:40 AM To 11:50 AM', val: '11:40 11:50' }, { text: '11:50 AM To 12:00 PM', val: '11:50 12:00' }, { text: '12:00 PM To 12:10 PM', val: '12:00 12:10' }, { text: '12:10 PM To 12:20 PM', val: '12:10 12:20' }, { text: '12:20 PM To 12:30 PM', val: '12:20 12:30' }, { text: '12:30 PM To 12:40 PM', val: '12:30 12:40' }, { text: '12:40 PM To 12:50 PM', val: '12:40 12:50' }, { text: '12:50 PM To 01:00 PM', val: '12:50 01:00' }, { text: '01:00 PM To 01:10 PM', val: '01:00 01:10' }, { text: '01:10 PM To 01:20 PM', val: '01:10 01:20' }, { text: '01:20 PM To 01:30 PM', val: '01:20 01:30' }, { text: '01:30 PM To 01:40 PM', val: '01:30 01:40' }, { text: '01:40 PM To 01:50 PM', val: '01:40 01:50' }, { text: '01:50 PM To 02:00 PM', val: '01:50 02:00' }, { text: '02:00 PM To 02:10 PM', val: '02:00 02:10' }, { text: '02:10 PM To 02:20 PM', val: '02:10 02:20' }, { text: '02:20 PM To 02:30 PM', val: '02:20 02:30' }, { text: '02:30 PM To 02:40 PM', val: '02:30 02:40' }, { text: '02:40 PM To 02:50 PM', val: '02:40 02:50' }, { text: '02:50 PM To 03:00 PM', val: '02:50 03:00' }, { text: '03:00 PM To 03:10 PM', val: '03:00 03:10' }, { text: '03:10 PM To 03:20 PM', val: '03:10 03:20' }, { text: '03:20 PM To 03:30 PM', val: '03:20 03:30' }, { text: '03:30 PM To 03:40 PM', val: '03:30 03:40' }, { text: '03:40 PM To 03:50 PM', val: '03:40 03:50' }, { text: '03:50 PM To 04:00 PM', val: '03:50 04:00' }, { text: '04:00 PM To 04:10 PM', val: '04:00 04:10' }, { text: '04:10 PM To 04:20 PM', val: '04:10 04:20' }, { text: '04:20 PM To 04:30 PM', val: '04:20 04:30' }, { text: '04:30 PM To 04:40 PM', val: '04:30 04:40' }, { text: '04:40 PM To 04:50 PM', val: '04:40 04:50' }, { text: '04:50 PM To 05:00 PM', val: '04:50 05:00' }, { text: '05:00 PM To 05:10 PM', val: '05:00 05:10' }, { text: '05:10 PM To 05:20 PM', val: '05:10 05:20' }, { text: '05:20 PM To 05:30 PM', val: '05:20 05:30' }, { text: '05:30 PM To 05:40 PM', val: '05:30 05:40' }, { text: '05:40 PM To 05:50 PM', val: '05:40 05:50' }, { text: '05:50 PM To 06:00 PM', val: '05:50 06:00' }]
}







// Testing live server API Base Url
// case 'vehicleTrackingBaseUrlApi': return 'https://mahakhanij.com/'; break;
// case 'stplVtsTrackingBaseUrlAPI': return 'https://mahakhanij.com/'; break;
// case 'masterBaseurlApi': return ' https://mahakhanij.com/'; break;
// case 'mineralBaseurlApi': return 'https://mahakhanij.com/'; break;
// case 'accountingBaseurlApi': return 'https://mahakhanij.com/'; break;
// case 'mineralMappingApi': return 'https://mahakhanij.com/mineral-mapping/'; break;
// case 'mineralProjectApi': return 'https://mahakhanij.com/mineral-project/'; break;
// default: return 'https://mahakhanij.com/'; break;
